const CLASSIFICATION_OPT = [
  {
    value: 'development',
    text: 'Development',
    disabled: false,
  },
  {
    value: 'publishing',
    text: 'Publishing',
    disabled: false,
  },
  {
    value: 'finance',
    text: 'Finance',
    disabled: false,
  },
];

const POSITION_OPT = [
  {
    value: 'business_owner',
    text: 'Business Owner',
    disabled: false,
  },
  {
    value: 'pteam_contact',
    text: 'P-team Contact',
    disabled: false,
  },
  {
    value: 'finance_contact',
    text: 'Finance Contact',
    disabled: false,
  },
];

const DEFAULT_ITEM = {
  project_owner: '',
  list: null,
};

export { CLASSIFICATION_OPT, DEFAULT_ITEM, POSITION_OPT };
